export const DAILY_GUESS_ROWS = 6;
export const DAILY_MIN_ZOOM = 100;
export const DAILY_INTERPOLATION_INITIAL_ZOOM = 600;
export const DAILY_INTERPOLATION_MIN_ZOOM = DAILY_MIN_ZOOM;
export const DAILY_ZOOM_BOUNDS = Object.freeze({
  initialZoom: DAILY_INTERPOLATION_INITIAL_ZOOM,
  minZoom: DAILY_INTERPOLATION_MIN_ZOOM,
});
export const DAILY_DEFAULT_ZOOM_RADIUS = 0.4095;
export const DAILY_DEFAULT_ZOOM_ORIGIN = { x: 0.5, y: 0.5 };
export const DAILY_ERROR_DISPLAY_MS = 2000;
export const DAILY_WIN_MODAL_DELAY_MS = 1900;
// Daily share-card numbering uses UTC calendar days from this launch day.
export const DAILY_CARD_NUMBER_START_DATE_UTC = '2026-02-13';
export const DAILY_CARD_NUMBER_START = 1;

